export default __webpack_public_path__ + "static/media/vacation.27404c1d.png";